function fetchOuDetailsQuery (id) {
  let variables = { id }

  return {
    operationName: 'fetchOuDetailsQuery',
    query: `
      query fetchOuDetailsQuery ($id: ID!) {
        organisationalUnit (id: $id) {
          stringRep: _stringRep
          description {
            de
            en
          }
          begin
          end
        }
      }
    `,
    variables
  }
}

export { fetchOuDetailsQuery }



// WEBPACK FOOTER //
// ./src/graphql/ouDetails.js